module.exports = __webpack_public_path__ + "static/21-b18f47ebbc78d15401557883bc0957c3.png";